import React from 'react';
import PropTypes from 'prop-types';
import { getColor } from 'core/utils/Styles';

const CaretRight = (props) => (
	<svg width="7" height="11" viewBox="0 0 7 11" {...props}>
		<path d="M157.414,154.828 L156,153.414 L160,149.414 L156,145.414 L157.414,144 L162.121,148.707 C162.512,149.098 162.512,149.73 162.121,150.121 L157.414,154.828 Z" transform="translate(-156 -144)"/>
	</svg>
);

CaretRight.propTypes = {
	fill: PropTypes.string,
};

CaretRight.defaultProps = {
	fill: getColor("gray"),
};

export default CaretRight;
